/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { useUserRole } from "../../partner-access/hooks/usePartnerAccess"
import { FormControl, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import { FormSelect } from "@carrotfertility/carotene-core-x"
import { useWatch } from "react-hook-form"
import { useCurrentUser } from "components/context/user/UserContext"
import { getSupportedLocaleDisplayName, getSupportedLocales } from "../app/IntlMessages"

const getPreferredLocaleOptions = (countryCode: string): { value: string; label: string }[] => {
  const supportedLocales = getSupportedLocales(countryCode)

  return supportedLocales.map((locale) => ({
    value: locale.toString(),
    label: getSupportedLocaleDisplayName(locale)
  }))
}

export const PreferredLocale = (): JSX.Element => {
  const intl = useIntl()

  const { isPartnerAccessingAccount } = useUserRole()
  const formValues = useWatch({ name: "preferredLocale" })
  const theme = useTheme()

  const { company } = useCurrentUser()

  const preferredLocaleMessage = intl.formatMessage({
    defaultMessage: "Preferred Language",
    description: "preferred language on account settings page"
  })
  const countryCode = company?.countryCode
  const preferredLocaleOptions = getPreferredLocaleOptions(countryCode)
  const userGeoSupportsLocaleSelection = preferredLocaleOptions.length > 1

  return (
    <Stack spacing="">
      <Typography variant="h2">
        <FormattedMessage defaultMessage="Language" />
      </Typography>
      <Stack spacing={theme.spacing(theme.tokens.spacing.lg)}>
        <Typography variant="body1">
          {userGeoSupportsLocaleSelection ? (
            <FormattedMessage defaultMessage="You'll see your Carrot account and all communications from Carrot in your preferred language." />
          ) : (
            <FormattedMessage defaultMessage="Languages other than U.S. English are currently available in the US and Canada only." />
          )}
        </Typography>
        <FormControl fullWidth>
          <FormSelect
            disabled={isPartnerAccessingAccount || !userGeoSupportsLocaleSelection}
            label={preferredLocaleMessage}
            name={"preferredLocale"}
            options={preferredLocaleOptions}
            defaultValue={formValues}
            style={{ textTransform: "capitalize" }}
          />
        </FormControl>
      </Stack>
    </Stack>
  )
}
